import {
  AccountantRoles,
  AdminRoles,
  LiaisonOfficerRoles,
  ProofReaderRoles,
  UserRole,
} from '@/core/types/user-role.enum'

export function isAdminRole(roles: UserRole[] | undefined): boolean {
  return roles?.some((role) => AdminRoles.includes(role)) ?? false
}

export function isProofReaderRole(roles: UserRole[] | undefined): boolean {
  return roles?.some((role) => ProofReaderRoles.includes(role)) ?? false
}

export function isLiaisonOfficerRole(roles: UserRole[] | undefined): boolean {
  return roles?.some((role) => LiaisonOfficerRoles.includes(role)) ?? false
}

export function isAccountantRole(roles: UserRole[] | undefined): boolean {
  return roles?.some((role) => AccountantRoles.includes(role)) ?? false
}
